<template>
  <div class="card">
    <div class="card-content">
      <question-title :question="question" class="mb2"></question-title>

      <ul class="case-grid">
        <li
          v-for="field in question.fields"
          v-bind:key="field.choice"
          :class="[
            'is-fullwidth',
            'mb1',
            { 'is-primary': choice === field.choice }
          ]"
        >
          <div class="image">
            <img
              :src="field.image.src"
              :alt="field.image.title"
              v-if="field.image"
            />
          </div>
          <h4>{{ field.choice }}</h4>
          <button
            :class="['button', 'is-primary', { 'is-loading': loading }]"
            v-on:click="recordAnswer(field)"
          >
            Consult Now
          </button>
        </li>
      </ul>

      <next-button
        ref="nextButton"
        :id="question.id"
        :choice="choice"
      ></next-button>
    </div>
  </div>
</template>

<script>
import baseQuestion from "./baseQuestion";
import VisuwellService from "../../services/VisuwellService";

export default {
  name: "casegrid",

  mixins: [baseQuestion],
  computed: {
    patientQueueId() {
      return this.$store.state.interview.patientQueue.id;
    }
  },
  methods: {
    recordAnswer(field) {
      this.loading = true;
      VisuwellService.startOnDemandSession(this.$store.state.interview.id, {
        patientQueueId: this.patientQueueId,
        ...field
      })
        .then(data => {
          this.loading = false;
          if (data.attributes && data.attributes.jwt) {
            this.choice = field.choice;
            this.$store.dispatch("interview/setNext", true);
            let onDemandSession = data.attributes;
            onDemandSession["id"] = data.id;
            this.$store.dispatch(
              "interview/setOnDemandSession",
              onDemandSession
            );
            this.$store.dispatch(
              "interview/setOnDemandRedirect",
              data.attributes["on-demand-redirect"]
            );
            this.$store.dispatch(
              "interview/setOnDemandJwt",
              data.attributes.jwt
            );
            this.$store.dispatch(
              "interview/setOnDemandAutologin",
              this.question.autologin
            );
            this.$nextTick(() => {
              let btn = this.$refs.nextButton.$el;
              if (btn) {
                btn.click();
              }
            });
          } else {
            alert("Something went wrong.");
          }
        })
        .catch(error => {
          this.loading = false;
          alert(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.case-grid {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 30px;
  li {
    width: 29%;
    margin-right: 3%;
    height: 400px;
    margin-bottom: 15px;
    box-shadow: 0px 4px 20px rgba(23, 128, 186, 0.2);
    text-align: center;
    padding-bottom: 40px;
    position: relative;
    .image {
    }
    h4 {
      font-size: 32px;
      text-align: center;
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .button {
      margin: 0 auto;
      width: 80%;
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      height: auto;
      white-space: initial;
      line-height: 32px;
      padding-top: 15px;
      padding-bottom: 15px;
    }
  }
}
</style>
